import React, { useState, useEffect } from 'react';
import { InputMask } from '@react-input/mask';
import TimePicker from '../../../components/utils/timepicker';
import CurrencyInput from "react-currency-input-field";
import api from '../../../config/axios';
import Swal from 'sweetalert2';

import { FaRegSave, FaTimes } from 'react-icons/fa';

const ServicoModal = ({ servico, categoriasLista, colaboradoresLista, onClose, onServicoAtualizado }) => {
    const [tituloModal, setTituloModal] = useState("");
    const [activeTab, setActiveTab] = useState('informacoes');
    const [categorias] = useState(categoriasLista);
    const [colaboradores, setColaboradores] = useState(colaboradoresLista);
    const [marcarTodosAssociados, setMarcarTodosAssociados] = useState(false);
    const [userType, setUserType] = useState('');

    const [formData, setFormData] = useState({
        nome: '',
        id_categoria: '',
        tempo: null,
        descricao: '',
        preco: '',
        custo: '',
        tipo_valor: '',
        sugerir_retorno: '',
        status: true
    });

    const formatarTempo = (tempo) => {
        if (!tempo) return null;

        if (typeof tempo === 'string') {
            if (tempo.length === 8 && tempo.includes(':')) {
                const [horas, minutos] = tempo.split(':');
                return convertHourToDate(`${horas}:${minutos}`);
            }

            if (tempo.length === 5) {
                return convertHourToDate(tempo);
            }
        }

        return null;
    };

    const convertHourToDate = (timeString) => {
        if (!timeString) return null;
        const [hours, minutes] = timeString.split(':');
        const date = new Date();
        date.setHours(parseInt(hours), parseInt(minutes), 0, 0);
        return date;
    };

    const convertDateToHour = (date) => {
        if (!date) return '00:00';
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
        return `${hours}:${minutes}`;
    };

    const validarTempo = (tempo) => {
        if (!tempo) return false;

        if (tempo instanceof Date) {
            return true;
        }

        return false;
    };

    useEffect(() => {
        const userDataArmazenado = localStorage.getItem('userData');
        if (userDataArmazenado) {
            const userData = JSON.parse(userDataArmazenado);
            if (userData.unidade_designacao_id && userData.gestora_designacao_id) {
                setUserType('colaborador');
            } else if (userData.gestora_designacao_id) {
                setUserType('gestor');
            } else {
                setUserType('master');
            }
        }
        
        if (servico != null) {
            getColaboradoresAssociados();
            setFormData({
                ...servico,
                descricao: servico.descricao || '',
                id_categoria: categorias.find(x => x.id == servico.id_categoria).id.toString(),
                preco: parseFloat(servico.preco).toFixed(2),
                custo: parseFloat(servico.custo).toFixed(2),
                tempo: formatarTempo(servico.tempo)
            });
            setTituloModal('Editar Serviço');
        }
        else setTituloModal('Novo Serviço');
    }, [servico]);

    const getColaboradoresAssociados = async () => {
        const response = await api.get(`/servicos/details/${servico.id_servico}`);
        
        const colaboradoresAssociados = response.data.colaboradoresAssociados.records;
        const resultado = colaboradores.map(item => {
            const associado = colaboradoresAssociados.find(obj => obj.id_pessoa === item.id)

            return {
                ...item,
                comissao: associado ? `${parseFloat(associado.comissao || 0).toFixed(2)}%` : '',
                comissao_assistente: associado ? `${parseFloat(associado.comissao_assistente || 0).toFixed(2)}%` : '',
                colaborador_tempo: associado ? (associado.tempo ? associado.tempo.substring(0, 5) : '') : '',
                esta_associado: !!associado
            };
        });

        setColaboradores(resultado);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const camposObrigatorios = [
            { campo: 'nome', label: 'Nome' },
            { campo: 'id_categoria', label: 'Categoria' },
            { campo: 'tempo', label: 'Duração' },
            { campo: 'preco', label: 'Valor Cobrado' },
            { campo: 'tipo_valor', label: 'Tipo Valor' }
        ];

        const camposInvalidos = camposObrigatorios.filter(({ campo }) => {
            const valor = formData[campo];

            if (campo === 'tempo') {
                return !valor || !(valor instanceof Date);
            }

            if (typeof valor === 'string') return !valor.trim();
            if (typeof valor === 'object' && valor !== null) return !valor.value;
            return !valor;
        });

        if (camposInvalidos.length > 0) {
            Swal.fire(
                'Erro',
                `Os seguintes campos são obrigatórios: ${camposInvalidos.map(c => c.label).join(', ')}`,
                'error'
            );
            return;
        }

        if (!validarTempo(formData.tempo)) {
            Swal.fire(
                'Erro',
                'Por favor, selecione uma duração válida.',
                'error'
            );
            return;
        }

        for (let i = 0; i < colaboradores.length; i++) {
            if (colaboradores[i].esta_associado && colaboradores[i].comissao.replace(/[^0-9.]/g, "") == '') {
                Swal.fire('Erro', 'Por favor, preencha a comissão dos colaboradores', 'error');
                return;
            }
            if (colaboradores[i].esta_associado && colaboradores[i].comissao_assistente.replace(/[^0-9.]/g, "") == '') {
                Swal.fire('Erro', 'Por favor, preencha a comissão assistente dos colaboradores', 'error');
                return;
            }
        }

        const data = {
            nome: formData.nome,
            preco: parseFloat(formData.preco.replace(',', '.')),
            id_categoria: formData.id_categoria,
            custo: formData.custo ? parseFloat(formData.custo.replace(',', '.')) : 0,
            descricao: formData.descricao,
            status: formData.status,
            tempo: convertDateToHour(formData.tempo),
            tipo_valor: formData.tipo_valor,
            sugerir_retorno: formData.sugerir_retorno || 0
        }

        Swal.fire({
            title: "Carregando...",
            allowOutsideClick: false,
            allowEscapeKey: false,
            showConfirmButton: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        try {
            if (servico != null) {
                await api.put(`/servicos/${servico.id_servico}`, data);
            }
            else {
                const response = await api.post(`/servicos`, data);

                servico = response.data;
            }

            //Salvar Aba Comissão
            const newColaboradoresAssociados = {};
            newColaboradoresAssociados.data = [];
            for (let i = 0; i < colaboradores.length; i++) {
                if (colaboradores[i].esta_associado) {
                    newColaboradoresAssociados.data.push({
                        id_pessoa_colaborador: colaboradores[i].id,
                        comissao: parseFloat(colaboradores[i].comissao.replace(/[^0-9.]/g, "")),
                        comissao_assistente: parseFloat(colaboradores[i].comissao_assistente.replace(/[^0-9.]/g, "")),
                        tempo: colaboradores[i].colaborador_tempo
                    })
                }
            }

            newColaboradoresAssociados.id_servico = servico.id_servico;

            await api.post(`/servicoColaboradores`, newColaboradoresAssociados);

            onServicoAtualizado();
            onClose();
            Swal.fire('Sucesso', 'Serviço salvo com sucesso!', 'success');
        }
        catch (error) {
            Swal.close();
            Swal.fire('Erro', `${error.response.data.message}`, 'error');
        }
    };

    const handleChangeInformacoes = (e) => {
        const { name, value } = e.target;

        if (name === 'tipo_valor' && value === 'sob consulta') {
            setFormData((prevState) => ({
                ...prevState,
                [name]: value,
                preco: '0,00'
            }));
        } else {
            setFormData((prevState) => ({
                ...prevState,
                [name]: value
            }));
        }
    };

    const handleChangeComissao = (e, index) => {
        const { name, value } = e.target;

        if (name === "comissao" || name === "comissao_assistente") {
            let inputValue = value.replace(/[^0-9.]/g, "");
            if (parseFloat(inputValue) > 100) inputValue = "100";

            const newColaboradores = [...colaboradores];
            if (inputValue != '') inputValue = inputValue + "%"
            newColaboradores[index] = {
                ...newColaboradores[index],
                [name]: inputValue
            };

            setColaboradores(newColaboradores);
        }

        if (name == 'esta_associado') {
            const newColaboradores = [...colaboradores];
            newColaboradores[index].esta_associado = !newColaboradores[index].esta_associado;
            newColaboradores[index].comissao = '0%';
            newColaboradores[index].comissao_assistente = '0%';
            if (newColaboradores[index].esta_associado && servico != null) newColaboradores[index].colaborador_tempo = convertDateToHour(formData.tempo);
            else newColaboradores[index].colaborador_tempo = '';
            setColaboradores(newColaboradores);

            const todosMarcados = newColaboradores.every(colaborador => colaborador.esta_associado);
            setMarcarTodosAssociados(todosMarcados);
        }
    };

    const handleMarcarTodosAssociados = () => {
        const novoValor = !marcarTodosAssociados;
        setMarcarTodosAssociados(novoValor);
        const atualizados = colaboradores.map(colaborador => ({
            ...colaborador,
            esta_associado: novoValor
        }));
        setColaboradores(atualizados);
    };

    return (
        <div className="modal fade show" tabIndex="-1" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered">
                <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                    <div className="modal-header">
                        <h4 className="fw-bold mt-2">{tituloModal}</h4>
                        <button type="button" className="btn-close" onClick={onClose} aria-label="Close"></button>
                    </div>

                    <div className="modal-body">
                        <form onSubmit={handleSubmit}>

                            <ul className="nav nav-tabs mt-3">
                                <li className="nav-item">
                                    <a
                                        className={activeTab === 'informacoes' ? 'nav-link active' : 'nav-link'}
                                        aria-current="page"
                                        onClick={() => setActiveTab('informacoes')}>
                                        Informações</a>
                                </li>
                                <li className="nav-item">
                                    <a
                                        className={activeTab === 'comissao' ? 'nav-link active' : 'nav-link'}
                                        aria-current="page"
                                        onClick={() => setActiveTab('comissao')}>
                                        Comissão</a>
                                </li>
                            </ul>

                            {activeTab === 'informacoes' && (
                                <div>
                                    <div className="row mt-3">
                                        <div className="col-lg-6 col-12">
                                            <label className="form-label fw-bold">Nome</label>
                                            <input
                                                type="text"
                                                name="nome"
                                                className="form-control"
                                                autoComplete="off"
                                                value={formData.nome.toUpperCase()}
                                                onChange={handleChangeInformacoes}
                                                disabled={userType === 'colaborador'}
                                                required
                                            />
                                        </div>
                                        <div className="col-lg-6 col-12 mt-lg-0 mt-3">
                                            <label className="form-label fw-bold">Categoria</label>
                                            <select
                                                name="id_categoria"
                                                className="form-control"
                                                value={formData.id_categoria}
                                                onChange={handleChangeInformacoes}
                                                disabled={userType === 'colaborador'}
                                            >
                                                <option value="" hidden>Selecione...</option>
                                                {categorias.map((option, index) => (
                                                    <option key={index} value={option.id}>
                                                        {option.nome}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                    <div className="row mt-3">
                                        <div className="col-lg-4 col-12">
                                            <label className="form-label fw-bold">Duração</label>
                                            <TimePicker
                                                value={formData.tempo}
                                                onChange={(time) => setFormData(prev => ({ ...prev, tempo: time }))}
                                                timeIntervals={15}
                                                className="form-control"
                                            />
                                        </div>
                                        <div className="col-lg-4 col-12 mt-lg-0 mt-3">
                                            <label className="form-label fw-bold">Status</label>
                                            <select
                                                name="status"
                                                className="form-control"
                                                value={formData.status}
                                                onChange={handleChangeInformacoes}
                                                disabled={userType === 'colaborador'}
                                            >
                                                <option value="true">Ativo</option>
                                                <option value="false">Inativo</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="row mt-3">
                                        <div className="col-12">
                                            <label className="form-label fw-bold">Descrição</label>
                                            <textarea
                                                name="descricao"
                                                className="form-control"
                                                autoComplete="off"
                                                rows="4"
                                                value={formData.descricao || ''}
                                                onChange={handleChangeInformacoes}
                                                disabled={userType === 'colaborador'}
                                            ></textarea>
                                        </div>
                                    </div>
                                    <div className="row mt-3">
                                        <div className="col-lg-3 col-12 mt-lg-0 mt-3">
                                            <label className="form-label fw-bold">Tipo Valor</label>
                                            <select
                                                name="tipo_valor"
                                                className="form-control"
                                                value={formData.tipo_valor}
                                                onChange={handleChangeInformacoes}
                                                disabled={userType === 'colaborador'}
                                            >
                                                <option value="">Selecione...</option>
                                                <option value="fixo">Fixo</option>
                                                <option value="a partir de">A partir de</option>
                                                <option value="sob consulta">Sob consulta</option>
                                            </select>
                                        </div>
                                        <div className="col-lg-3 col-12 mt-lg-0 mt-3">
                                            <label className="form-label fw-bold">Valor Cobrado</label>
                                            <CurrencyInput
                                                name="preco"
                                                placeholder="R$ 0,00"
                                                value={formData.preco}
                                                decimalsLimit={2}
                                                decimalSeparator=","
                                                groupSeparator="."
                                                prefix="R$ "
                                                className="form-control"
                                                disabled={formData.tipo_valor == 'sob consulta'}
                                                autoComplete="off"
                                                onValueChange={(value) =>
                                                    setFormData((prevState) => ({
                                                        ...prevState,
                                                        preco: value,
                                                    }))
                                                }
                                            />
                                        </div>
                                        <div className="col-lg-3 col-12 mt-lg-0 mt-3">
                                            <label className="form-label fw-bold">Custo do Serviço</label>
                                            <CurrencyInput
                                                name="custo"
                                                placeholder="R$ 0,00"
                                                value={formData.custo}
                                                decimalsLimit={2}
                                                decimalSeparator=","
                                                groupSeparator="."
                                                prefix="R$ "
                                                className="form-control"
                                                autoComplete="off"
                                                disabled={userType === 'colaborador'}
                                                onValueChange={(value) =>
                                                    setFormData((prevState) => ({
                                                        ...prevState,
                                                        custo: value,
                                                    }))
                                                }
                                            />
                                        </div>
                                        <div className="col-lg-3 col-12 mt-lg-0 mt-3">
                                            <label className="form-label fw-bold">Sugerir Retorno em</label>
                                            <div className="input-group">
                                                <input
                                                    type="number"
                                                    name="sugerir_retorno"
                                                    className="form-control"
                                                    autoComplete="off"
                                                    value={formData.sugerir_retorno}
                                                    onChange={handleChangeInformacoes}
                                                    disabled={userType === 'colaborador'}
                                                    required
                                                />
                                                <span className="input-group-text">dias</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {activeTab === 'comissao' && (
                                <div>
                                    <div className="row mt-3">
                                        <div className="col-12">
                                            <div className="table-responsive max-h-400">
                                                <table className="table table-striped">
                                                    <thead className="table-custom-primary">
                                                        <tr className="thead-fixed">
                                                            <th>
                                                                <div className="form-check d-flex justify-content-center">
                                                                    <input
                                                                        type="checkbox"
                                                                        className="form-check-input"
                                                                        checked={marcarTodosAssociados}
                                                                        onChange={handleMarcarTodosAssociados}
                                                                    />
                                                                </div>
                                                            </th>
                                                            <th>Nome</th>
                                                            <th>Comissão</th>
                                                            <th>Comissão Assistente</th>
                                                            <th>Tempo</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {colaboradores.map((colaborador, index) => (
                                                            <tr key={index}>
                                                                <td>
                                                                    <div className="form-check d-flex justify-content-center">
                                                                        <input
                                                                            type="checkbox"
                                                                            name="esta_associado"
                                                                            className="form-check-input"
                                                                            checked={colaborador.esta_associado || false}
                                                                            onChange={(event) => handleChangeComissao(event, index)}
                                                                        />
                                                                    </div>
                                                                </td>
                                                                <td className="text-nowrap">{colaborador.nome}</td>
                                                                <td>
                                                                    <input
                                                                        className="form-control"
                                                                        name="comissao"
                                                                        autoComplete="off"
                                                                        disabled={!colaborador.esta_associado}
                                                                        value={colaborador.comissao}
                                                                        style={{ width: '150px' }}
                                                                        onChange={(event) => handleChangeComissao(event, index)}
                                                                        placeholder="0%"
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        className="form-control"
                                                                        name="comissao_assistente"
                                                                        autoComplete="off"
                                                                        disabled={!colaborador.esta_associado}
                                                                        value={colaborador.comissao_assistente}
                                                                        style={{ width: '150px' }}
                                                                        onChange={(event) => handleChangeComissao(event, index)}
                                                                        placeholder="0%"
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <InputMask
                                                                        mask="__:__"
                                                                        replacement={{ _: /\d/ }}
                                                                        name="colaborador_tempo"
                                                                        className="form-control"
                                                                        autoComplete="off"
                                                                        disabled={true}
                                                                        value={colaborador.colaborador_tempo}
                                                                        style={{ width: '150px' }}
                                                                        onChange={(event) => handleChangeComissao(event, index)}
                                                                        placeholder="00:00"
                                                                    />
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </form>
                    </div>
                    <div className="modal-footer mt-4">
                        <div className="row">
                            <div className="col-12 text-end">
                                <button className="btn btn-outline-danger" type="button" onClick={onClose}>
                                    <FaTimes /> Fechar
                                </button>
                                <button className="btn btn-custom-primary ms-3" type="submit" onClick={handleSubmit}>
                                    <FaRegSave /> Salvar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    );
};

export default ServicoModal;
